// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageBreakWidget hr {\n  border-top: 2px dashed #A9B1BC; }\n", ""]);
// Exports
module.exports = exports;
